export * from './atlas-map.component'
